var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.99961 6.30005H0.0996094V17.3H3.99961V6.30005Z","key":0}),React.createElement("path",{"d":"M6.09961 6.30005H9.09961V7.80005C9.09961 7.80005 9.59961 6.30005 12.3996 6.30005C14.6996 6.30005 16.3996 7.20005 16.3996 9.70005C16.3996 11.1 16.3996 17.3 16.3996 17.3H13.1996C13.1996 17.3 13.1996 10.9 13.1996 10.7C13.1996 10.5 12.9996 8.90005 11.3996 8.90005C9.69961 8.90005 9.19961 10.1 9.19961 11C9.19961 11.9 9.19961 17.3 9.19961 17.3H6.09961V6.30005Z","key":1}),React.createElement("path",{"d":"M2.09961 4.80005C3.20418 4.80005 4.09961 3.90462 4.09961 2.80005C4.09961 1.69548 3.20418 0.800049 2.09961 0.800049C0.99504 0.800049 0.0996094 1.69548 0.0996094 2.80005C0.0996094 3.90462 0.99504 4.80005 2.09961 4.80005Z","key":2})]);
}

LinkedIn.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 17 18"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
